export function formatPlaceholder(selected_appointment_types) {
  return selected_appointment_types.length > 0
    ? `${selected_appointment_types.length} selected`
    : 'All appointment types'
}
